<template>
  <section>
    <div v-for="(record, index) in boardListData"
         :key="index"
         class="mdc-card mgb-24"
         @click="moveToDetail(record)"
         @keypress="moveToDetail(record)"
    >
      <div v-show="record.fixed" class="attach-pin position-absolute" tabindex="0">
        <img alt="" class="w-28 h-28 " src="/images/attach-pin.svg">
      </div>

      <div class="cursor-pointer pdt-24 pdb-16 pdl-24 pdr-24 b-radius4" tabindex="0" :class="{'bg-documentGray': record.isBlocked}">
        <div class="d-flex">
          <div class="list-image-small">
            <UserImgProfile :allData="record" :data="record.auditor.register" :className="'mgr-0'" />
          </div>
          <div class="flex-grow-1 pdl-16">
            <div class="d-flex justify-content-between">
              <div class="t-body1 mgb-1 font-r mgb-4" :class="{'t-color-bodyGrayB': record.isBlocked}">{{
                  record.auditor.register.name ? $t('3437', {
                    first: record.auditor.register.name.first,
                    last: record.auditor.register.name.last
                  }) : ''
                }}
              </div>
              <div class="t-body3 font-r t-color-bodyGrayA" :class="{'t-color-bodyGrayB': record.isBlocked}">{{
                  $moment(record.auditor.register.time).format("L")
                }}
              </div>
            </div>
            <div v-if="record.auditor.register.storeName" class="d-flex user-list-info mgt-4 font-r" :class="{'t-color-bodyGrayB': record.isBlocked}">
              <div v-if="record.auditor.register.storeName"
                   class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': record.isBlocked}">
                {{ record.auditor.register.storeName }}
              </div>
              <div class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': record.isBlocked}">
                {{ record.auditor.register.responsibilityName }}
              </div>

            </div>
            <div v-else class="t-body3 t-color-bodyGrayA pdr-8 mgr-8" :class="{'t-color-bodyGrayB': record.isBlocked}">
              {{ record.auditor.register.storeName ? record.auditor.register.storeName : brandName }}
            </div>
          </div>
        </div>
        <div v-if="record.contents && record.contents.body !== ''"
             class="t-body6 font-r t-line-4 t-color-bodyGrayA mgt-16 l-spacing45 t-line-h-25 t-prewrap" :class="{'t-color-bodyGrayB': record.isBlocked}">
          <div v-show="record.contents.subject" v-html="record.isBlocked ? $t('3814') : record.contents.subject"></div>
          <div v-html="record.isBlocked ? '' : listFilter(record.contents.body)"></div>
        </div>
        <div v-if="!record.isBlocked && record.tags && record.tags.length > 0" class="d-flex mgt-8 mgb-16 flex-wrap max-h-22 overflow-hidden">
          <div v-for="(tag, i) in record.tags" :key="i"
               class="pdl-4 pdr-4 b-radius2 mgr-4 mgt-4t-body3 font-r t-color-contentBlue bg-contentBlueInactive min-h-22 t-center mgb-10 t-body3 d-flex justify-content-center align-items-center">
            #{{ tag.name }}
          </div>
        </div>

        <div v-if="!record.isBlocked && record.contents.files.length === 1"
             class="mgt-16"
             @click.stop>
          <img v-if="getType(record.contents.files[0].contentType) === 'image'"
               id="single-image"
               :src="record.contents.files[0].resourceUri"
               alt=""
               class="square-image">
          <VideoComponent
              v-else
              :record="record.contents.files[0]"
              :videoSize="'large'"
              :fullSizeVideo="true">
          </VideoComponent>
        </div>

        <div v-if="!record.isBlocked && record.contents.files.length === 2" class="d-grid-2 mgt-16">
          <div v-for="(img,index1) in record.contents.files" :key="index1" class="square-image">
            <a href="javascript:void(0)" tabindex="0">
              <img v-if="getType(img.contentType) === 'image'" :src="img.resourceUri" alt="">
              <div v-if="getType(img.contentType) === 'video'">
                <img :src="img.subFileResourceUri[0] ? img.subFileResourceUri[0] : thumbnailUrl" alt="">
                <span class="video-play-button video-play-button-control">
                <div class="video-play-button-placeholder"></div>
              </span>
              </div>
            </a>
          </div>
        </div>

        <div v-if="!record.isBlocked && record.contents.files.length > 2" class="thee-plus-image mgt-16">
          <div class="square-image">
            <a href="javascript:void(0)" tabindex="0">
              <img v-if="getType(record.contents.files[0].contentType) === 'image'"
                   :src="record.contents.files[0].resourceUri" alt="">
              <div v-if="getType(record.contents.files[0].contentType) === 'video'">
                <img
                    :src="record.contents.files[0].subFileResourceUri[0] ? record.contents.files[0].subFileResourceUri[0] : thumbnailUrl"
                    alt="">
                <span class="video-play-button video-play-button-control">
                  <div class="video-play-button-placeholder"></div>
                </span>
              </div>
            </a>
          </div>
          <div class="other-images">
            <div class="square-image">
              <a href="javascript:void(0)" tabindex="0">
                <img v-if="getType(record.contents.files[1].contentType) === 'image'"
                     :src="record.contents.files[1].resourceUri" alt="">
                <img v-else
                     :src="record.contents.files[1].subFileResourceUri[0] ? record.contents.files[1].subFileResourceUri[0] : thumbnailUrl"
                     alt="">
              </a>
            </div>
            <div class="square-image">
              <a class="more" href="javascript:void(0)">
                <img v-if="getType(record.contents.files[2].contentType) === 'image'"
                     :src="record.contents.files[2].resourceUri" alt="">
                <div v-if="getType(record.contents.files[2].contentType) === 'video'">
                  <img
                      :src="record.contents.files[2].subFileResourceUri[0] ? record.contents.files[2].subFileResourceUri[0] : thumbnailUrl"
                      alt="">
                  <div v-show="record.contents.files.length <= 3">
                      <span class="video-play-button video-play-button-control">
                    <div class="video-play-button-placeholder"></div>
                  </span>
                  </div>
                </div>
                <span v-if=" (record.contents.files.length - 3 ) > 0 " class="t-color-whiteHigh t-headline8">
											+{{ record.contents.files.length - 3 }}
                </span>
              </a>
            </div>
          </div>
        </div>

        <div v-if="!record.isBlocked" class="d-flex justify-content-between align-items-center mgt-16" tabindex="0" @click="moveToDetail(record)" @keypress="moveToDetail(record)">
          <div class="d-flex flex-grow-1">
            <div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1430", {str: record.likesCount}) }}</div>
            <div class="t-color-bodyGrayB t-helper font-r pdr-24">{{ $t("1431", {str: record.commentCount}) }}</div>
          </div>
          <div class="t-color-bodyGrayB t-helper font-r ">{{ $t("1432", {str: record.viewCount}) }}</div>
        </div>
      </div>
      <div v-if="!record.isBlocked" class="divider  mgl-24 mgr-24"></div>
      <div v-if="!record.isBlocked" class="d-flex justify-content-evenly pdt-13 pdb-13">
        <button class="mdc-button" tabindex="0"
                @click.stop
                @click="patchLikeState(record.id, record.like,record); record.like = !record.like"
                >
          <span class="mdc-button__ripple"></span>
          <i :class="record.like ? 't-color-red' : 't-color-iconInactive'" aria-hidden="true"
             class="material-icons mdc-button__icon font-16-6">{{ record.like ? 'favorite' : 'favorite_border' }}</i>
          <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1433") }}</span>
        </button>
        <button class="mdc-button" tabindex="0" >
          <span class="mdc-button__ripple"></span>
          <i aria-hidden="true" class="material-icons mdc-button__icon t-color-iconInactive font-16-6">
            chat_border
          </i>
          <span class="mdc-button__label t-body3 font-r t-color-iconInactive">{{ $t("1434") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>

import socialApi from "@/api/socialApi";
import VideoComponent from "@/components/common/VideoComponent.vue";
import {fileMixin} from "@/mixins/file";
import localStorageUtil from "@/utils/localStorageUtil";

export default {
  props: ['boardListData'],

  name: "SocialLearningComponent",

  mixins: [fileMixin],

  components: {
    VideoComponent,
    UserImgProfile: () => import("@/components/common/checkUser/UserImgProfile.vue"),
},

  data() {
    return {
      boardId: this.$route.params.board,
      boardName: this.$route.query.boardName,
      bgColorOfName: localStorageUtil.getBgColor(),
      thumbnailUrl: require("@/images/blackBackground.jpg"),
      brandName: localStorage.getItem("brandName"),
    }
  },

  methods: {
    /**
     *
     * @param {object} name 사용자 이름
     * @returns {string}
     */
    firstCharOfMemberName(name) {
      if (name.first) {
        let fullName = this.$t('3437', {first: name.first, last: name.last});
        return fullName.charAt(0);
      } else {
        let fullName = name.fullName;
        return fullName.charAt(1);
      }
    },

    /**
     * method to redirect the user on Detail page if exists
     * @param {object} record 게시판
     */
    moveToDetail(record) {
      if (record && record.id) {
        this.$router.push('/socialLearning/' + this.boardId + '/' + record.id + '?boardName=' + encodeURIComponent(this.boardName));
      }
    },

    patchLikeState(id, status, record) {
      this.$showLoading();
      let action = status
          ? socialApi.patchPostLike(this.boardId, id)
          : socialApi.patchPostDislike(this.boardId, id);

      action
          .then(response => {
            this.$hideLoading();
            record.likesCount = response.data.data.likesCount;
          })
          .catch(err => {
            this.$error({content: err.errMsg}).then(() => {
            });
          });
    },
  }
}
</script>

<style scoped>
.video-js video {
  width: 100%;
  height: 100%;
}

#single-image {
  margin: auto;
  display: block;
  width: auto !important;
  height: auto !important;
  max-width: 718px !important;
  max-height: 718px !important;
}
</style>
